export default __webpack_public_path__ + "static/media/icon-playbooks.feea9da1.svg";